import { useSWRConfig } from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export interface AssignHostsRoundRobinRequest {
  eventId: number;
  contactIds: number[];
}

export function useAssignHostsRoundRobin() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    request: AssignHostsRoundRobinRequest,
  ): Promise<{ success: boolean }> =>
    service
      .post(
        `/api/webinars/${request.eventId}/follow-up/assign-hosts-round-robin`,
      )
      .set(headers)
      .send({
        contactIds: request.contactIds,
      })
      .then(tokenRefreshHandler)
      .then((res: Response) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate webinar queries to refresh the data
        Array.from(keys)
          .filter((r: any) => r.includes("/api/webinars"))
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .then((res: Response) => res.body)
      .catch(errorHandler);
}

export default useAssignHostsRoundRobin;
